require('./loansCreditsMoreOptionsButton.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ components
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
// @constants
const {
    LOANS_MORTGAGES_PREGRANTED_CREDIT,
    LOANS_MORTGAGES_INVESTMENT_CREDIT
} = require('constants/index');
const {
    LOANS_MORTGAGES_MORTGAGE_LOAN,
    LOANS_MORTGAGES_PAYROLL_LOAN,
    LOANS_MORTGAGES_PERSONAL_LOAN,
    LOANS_MORTGAGES_PREAPPROVED_LOAN,
    LOANS_MORTGAGES_RETAIL_LOAN,
    LOANS_MORTGAGES_ARES_LOAN,
    MORE_OPTIONS,
    PARTIAL_AMORTIZATION_811,
    PRODUCT_TYPE_143
} = require('../../../loansConstants/index');
// @ utilities
const { removeCurrentSectionOption } = require('utilities/moreOptionsHelper');
const { recordLinkV2 } = require('utilities/tagging');

class LoansCreditsMoreOptionsButton extends React.Component {
    handleOnClick(option) {
        recordLinkV2({
            categoriaEvento: window.utag_last_name,
            accionEvento: "mas opciones",
            etiquetaEvento: option,
        });
    }

    getOption(id, option, isRestricted, prefix = 'loans') {
        const { productSubType, productType } = this.props;
        const options = {
            LOAN_INFORMATION: {
                handleClick: () => this.handleOnClick(formatText('loanMoreOptions-loanInformation')),
                link: `/myprofile/loans-mortgages/${prefix}/${id}`,
                text: formatText('loanMoreOptions-loanInformation')
            },
            MOVEMENTS: {
                handleClick: () => this.handleOnClick(formatText('loanMoreOptions-seeMovements')),
                link: `/myprofile/loans-mortgages/${prefix}/${id}/movements`,
                text: formatText('loanMoreOptions-seeMovements')
            },
            INVESTMENTS_MOVEMENTS: {
                link: `/myprofile/loans-mortgages/${prefix}/${id}/${LOANS_MORTGAGES_INVESTMENT_CREDIT}/movements`,
                text: formatText('loanMoreOptions-seeMovements')
            },
            AMORTIZATION_PLAN: {
                handleClick: () => this.handleOnClick(formatText('loanMoreOptions-amortizationPlan')),
                visible: !isRestricted,
                link: `/myprofile/loans-mortgages/${prefix}/${id}/repayment-plan`,
                text: formatText('loanMoreOptions-amortizationPlan')
            },
            PARTIAL_AMORTIZATION: {
                visible: !isRestricted && !(productSubType === PARTIAL_AMORTIZATION_811 && productType === PRODUCT_TYPE_143),
                link: `/myprofile/loans-mortgages/${prefix}/${id}/partial-amortization`,
                text: formatText('loanMoreOptions-partialAmortization')
            },
            LIQUIDATIONS: {
                visible: !isRestricted,
                link: `/myprofile/loans-mortgages/${prefix}/${id}/settlements`,
                text: formatText('loanMoreOptions-liquidations')
            },
            UNPAID_FEES: {
                handleClick: () => this.handleOnClick(formatText('loanMoreOptions-unpaidFees')),
                visible: !__CONTACT_CENTER__,
                link: `/myprofile/loans-mortgages/${prefix}/${id}/unpaid-fees`,
                text: formatText('loanMoreOptions-unpaidFees')
            },
            CHANGE_ACCOUNT: {
                visible: !isRestricted,
                link: `/myprofile/loans-mortgages/${prefix}/${id}/modify-associated-account`,
                text: formatText('loanMoreOptions-changeAssociatedAccount')
            },
            CREDIT_INFORMATION: {
                link: `/myprofile/loans-mortgages/${prefix}/${id}`,
                text: formatText('loanMoreOptions-creditInformation')
            },
            LIMIT_VARIATION: {
                link: `/myprofile/loans-mortgages/${prefix}/${id}/credit-pregranted-modify-limit`,
                text: formatText('loanMoreOptions-limitVariation')
            },
            CANCELLATION: {
                link: `/myprofile/loans-mortgages/${prefix}/${id}/cancel`,
                text: formatText('loanMoreOptions-cancellation')
            },
            SETTLEMENTS: {
                link: `/myprofile/loans-mortgages/${prefix}/${id}/${LOANS_MORTGAGES_INVESTMENT_CREDIT}/settlements`,
                text: formatText('loanMoreOptions-settlements')
            },
            WARRANTIES: {
                visible: __CONTACT_CENTER__,
                link: `/myprofile/loans-mortgages/credit/investment-credit/${id}/warranties`,
                text: formatText('loanMoreOptions-warranties')
            }
        };
        return options[option];
    }

    buildInvestmentOptions(id, isRestrictedLoan) {
        const { isARES } = this.props;
        return isARES ?
            [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION, false, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS, false, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES, false, 'ares-loans')
            ] : [
                this.getOption(id, MORE_OPTIONS.CREDIT_INFORMATION, false, 'credit/investment-credit'),
                this.getOption(id, MORE_OPTIONS.SETTLEMENTS, false, 'credit'),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.PARTIAL_AMORTIZATION, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES),
                this.getOption(id, MORE_OPTIONS.WARRANTIES)
            ];
    }

    buildMortgageOptions(id, isRestrictedLoan) {
        const { isARES } = this.props;
        return isARES ?
            [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION, false, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS, false, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES, false, 'ares-loans')
            ] : [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.PARTIAL_AMORTIZATION, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.LIQUIDATIONS, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES)
            ];
    }

    buildPersonalOptions(id, isRestrictedLoan) {
        const { isARES } = this.props;
        return isARES ?
            [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION, false, 'ares-loans'),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS, false, 'ares-loans'),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan, 'ares-loans'),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES, false, 'ares-loans')
            ] : [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.PARTIAL_AMORTIZATION, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.LIQUIDATIONS, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES)
            ];
    }

    buildPayrollOptions(id, isRestrictedLoan) {
        const { isARES } = this.props;
        return isARES ?
            [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION, false, 'ares-loans'),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS, false, 'ares-loans'),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan, 'ares-loans'),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES, false, 'ares-loans')
            ] : [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.PARTIAL_AMORTIZATION, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.LIQUIDATIONS, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES),
                this.getOption(id, MORE_OPTIONS.CHANGE_ACCOUNT, isRestrictedLoan),
            ];
    }

    buildPreapprovedOptions(id, isRestrictedLoan) {
        const { isARES } = this.props;
        return isARES ?
            [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION, false, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS, false, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES, false, 'ares-loans')
            ] : [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION, false, 'preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS, false, 'preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan, 'preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.PARTIAL_AMORTIZATION, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES),
                this.getOption(id, MORE_OPTIONS.CHANGE_ACCOUNT, isRestrictedLoan, 'preapproved-loans')
            ];
    }

    buildPregrantedOptions(id) {
        const { isARES } = this.props;
        return isARES ?
            [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION, false, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS, false, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, false, 'ares-preapproved-loans'),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES, false, 'ares-loans')
            ] : [
                this.getOption(id, MORE_OPTIONS.CREDIT_INFORMATION, false, 'credit/pregranted-credit'),
                this.getOption(id, MORE_OPTIONS.LIMIT_VARIATION, false, 'credit'),
                this.getOption(id, MORE_OPTIONS.CANCELLATION, false, 'credit')
            ];
    }

    buildAresOptions(id, isRestrictedLoan) {
        const { isARES } = this.props;
        return isARES ?
            [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION, false, 'ares-loans'),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS, false, 'ares-loans'),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan, 'ares-loans'),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES, false, 'ares-loans')
            ] : [
                this.getOption(id, MORE_OPTIONS.LOAN_INFORMATION),
                this.getOption(id, MORE_OPTIONS.MOVEMENTS),
                this.getOption(id, MORE_OPTIONS.AMORTIZATION_PLAN, isRestrictedLoan),
                this.getOption(id, MORE_OPTIONS.UNPAID_FEES),
            ];
    }

    buildOptions() {
        const { id, type, isRestrictedLoan } = this.props;
        let options;

        switch (type) {
            case LOANS_MORTGAGES_PREGRANTED_CREDIT:
                options = this.buildPregrantedOptions(id);
                break;
            case LOANS_MORTGAGES_INVESTMENT_CREDIT:
                options = this.buildInvestmentOptions(id, isRestrictedLoan);
                break;
            case LOANS_MORTGAGES_PERSONAL_LOAN:
                options = this.buildPersonalOptions(id, isRestrictedLoan);
                break;
            case LOANS_MORTGAGES_MORTGAGE_LOAN:
                options = this.buildMortgageOptions(id, isRestrictedLoan);
                break;
            case LOANS_MORTGAGES_PREAPPROVED_LOAN:
                options = this.buildPreapprovedOptions(id, isRestrictedLoan);
                break;
            case LOANS_MORTGAGES_PAYROLL_LOAN:
            case LOANS_MORTGAGES_RETAIL_LOAN:
                options = this.buildPayrollOptions(id, isRestrictedLoan);
                break;
            case LOANS_MORTGAGES_ARES_LOAN:
                options = this.buildAresOptions(id, isRestrictedLoan);
                break;
            default:
                return [];
        }
        return options;
    }

    render() {
        const allOptions = this.buildOptions();
        const moreOptions = removeCurrentSectionOption(allOptions);
        const targetElement = (
            <div className="loan-more-options-button">
                <OKButton
                    modifier="ghost"
                    inverse={true}
                    rightIcon="icon-dropdown-abrir"
                    smallRightIcon={true}
                >
                    <FormattedText value="loanMovements-moreOptions" />
                </OKButton>
            </div>
        );

        return (
            <PopoverMenu dropdownStyle="loans-credits-more-options-button__dropdown"
                target={targetElement}
                items={moreOptions}
                placement="bottomRight"
            />
        );
    }
}

LoansCreditsMoreOptionsButton.propTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    isRestrictedLoan: PropTypes.bool,
    isARES: PropTypes.bool,
};

LoansCreditsMoreOptionsButton.defaultProps = {
    isRestrictedLoan: false,
    isARES: false
};

module.exports = LoansCreditsMoreOptionsButton;
